<template>
  <b-modal
    :id="id"
    dialog-class="base-modal"
    scrollable
    hide-header
    hide-header-close
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    centered
  >
    <div class="title">
      <slot name="title"></slot>
    </div>

    <div v-if="!noContent" class="modal-content">
      <slot name="content"></slot>
    </div>

    <div class="btn-wrapper" :class="{ 'cancel-on': cancelBtn }">
      <div v-if="cancelBtn" class="modal-btn cancel" @click="clickCancel">
        <slot name="cancel">{{ $t('modal.cancel') }}</slot>
      </div>
      <div class="modal-btn confirm" @click="clickConfirm">
        <slot name="confirm">{{ $t('modal.confirm') }}</slot>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'BaseModal',
  props: {
    id: String,
    clickConfirmText: String,
    'cancel-btn': {
      type: Boolean,
      default: false,
    },
    'no-content': {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
    }),
  },
  data() {
    return {};
  },
  methods: {
    clickCancel() {
      this.$emit('clickCancel');
    },
    clickConfirm() {
      this.$emit('clickConfirm');
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';

.modal-dialog.base-modal {
  max-width: 420px;
  margin: 0 auto;
  line-height: 1.2;

  @include mobile {
    min-width: 320px;
    max-width: 95%;
  }

  .modal-content {
    border-radius: 8px;
    line-height: 1.5;

    .modal-body {
      padding: 0;

      .title {
        font-weight: 600;
        color: #333333;
        font-size: 22px;
        padding: 28px 28px 0;

        @include mobile {
          font-size: 20px;
          padding: 22px 20px 0;
        }
      }

      .modal-content {
        display: inherit;
        font-size: 16px;
        padding-left: 28px;
        padding-top: 14px;
        padding-bottom: 0 !important;
        font-weight: 500;
        color: #666666;

        .gap-rows {
          display: grid;
          gap: 10px;
        }

        @include mobile {
          font-size: 14px;
          padding-left: 22px;
          padding-top: 10px;
        }
      }

      .btn-wrapper {
        padding: 20px 24px;

        @include mobile {
          padding: 20px;
          padding-bottom: 16px;
        }

        &.cancel-on {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 10px;
        }

        .modal-btn {
          font-weight: 400;
          height: 52px;
          font-size: 18px;
          cursor: pointer;
          width: 100%;
          border-radius: 4px;
          display: grid;
          place-items: center;

          @include mobile {
            height: 42px;
            font-size: 16px;
          }

          &.confirm {
            background: #3c7eea;
            color: white;
            text-align: center;
          }

          &.cancel {
            background: #f2f4f6;
            color: #333333;
          }
        }
      }
    }
  }

  input[type='text'] {
    padding: 15px 16px;
    width: 100%;
    height: 52px;
    outline: 0;
    border: 1px solid #f2f4f6;
    border-radius: 4px;
    color: #333333;

    &::placeholder {
      font-weight: 500;
      font-size: 18px;
      color: #999999;

      @include mobile {
        font-size: 16px;
      }
    }
  }
}
</style>
